export async function queryKnowledgeBase(prompt: string, studio_mode?: string): Promise<{response: string, usage: any}> {
  const bodyData: any = { prompt };
  if (studio_mode) {
    bodyData.studio_mode = studio_mode;
  }
  
  const res = await fetch("/api/kb/query", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bodyData),
  });
  
  if (!res.ok) {
    let errorMsg = res.statusText;
    try {
      const errorData = await res.json();
      if (errorData.detail) {
        errorMsg = typeof errorData.detail === 'string' ? errorData.detail : JSON.stringify(errorData.detail);
      }
    } catch (e) {
      // Ignore JSON parse error if body is empty
    }
    throw new Error(`Error en API KB: ${errorMsg}`);
  }
  
  const data = await res.json();
  return data;
}
